import React from 'react';
import { Box, Skeleton } from '@mantine/core';

interface SidebarCategorySkeletonProps {
  count?: number;
}

export const SidebarCategorySkeleton: React.FC<SidebarCategorySkeletonProps> = ({ count = 5 }) => {
  return (
    <Box style={{ flex: 1 }}>
      {Array.from({ length: count }).map((_, index) => (
        <Box key={index} mb={8}>
          <Skeleton height={40} width='100%' radius={4} />
        </Box>
      ))}
    </Box>
  );
};
